import { Box, Tooltip, Typography } from '@mui/material';
import { Colors } from '../../constants/theme';
import { formatDateTime } from '../timeAgo';

type ProcessStatusProps = {
  value?: number | null;
  lastUpdated?: string | null;
};

const BAR_WIDTH = 80;
const BAR_HEIGHT = 7;

const toPercent = (value?: number | null) => {
  if (typeof value !== 'number' || Number.isNaN(value)) {
    return null;
  }

  return Math.min(100, Math.max(0, Math.round(value * 100)));
};

const textSx = {
  fontFamily: 'Futura',
  fontSize: 14,
  fontWeight: 400,
  lineHeight: 1,
  color: Colors.light.text,
  whiteSpace: 'nowrap',
};

export const ProcessStatusProgress = ({ value, lastUpdated }: ProcessStatusProps) => {
  const percent = toPercent(value);
  const lastUpdatedLabel = lastUpdated ? formatDateTime(lastUpdated) : null;
  const tooltip = lastUpdatedLabel
    ? `Last updated: ${lastUpdatedLabel}`
    : 'Last updated: —';
  const label =
    percent === null ? 'Process status not set' : `Process status ${percent}%`;

  return (
    <Tooltip title={tooltip} placement="top" arrow>
      <Box
        aria-label={`${label}. ${tooltip}`}
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          minWidth: 0,
          width: 'fit-content',
        }}
      >
        <Box
          sx={{
            width: BAR_WIDTH,
            height: BAR_HEIGHT,
            borderRadius: BAR_HEIGHT / 2,
            backgroundColor: Colors.light.lightGrey,
            overflow: 'hidden',
            flexShrink: 0,
          }}
        >
          <Box
            sx={{
              width: `${percent ?? 0}%`,
              height: '100%',
              backgroundColor: Colors.light.green,
            }}
          />
        </Box>
        <Typography component="span" sx={textSx}>
          {percent === null ? '—' : `${percent}%`}
        </Typography>
      </Box>
    </Tooltip>
  );
};
